import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { Button, useTheme } from '@mui/material';

import { loginSuccess } from '../../../redux/slices/auth';
import Iconify from '../../common/Iconify';

const GoogleLoginForm = () => {
  const theme = useTheme();
  // Google login hook to handle auth-code flow
  const googleLogin = useGoogleLogin({
    flow: 'auth-code',
    onSuccess: async (codeResponse) => {
      try {
        // Send the authorization code to the backend for token exchange
        const tokens = await axios.post('ecommerce/auth/google/', {
          code: codeResponse.code,
        });
        loginSuccess(tokens.data); // Store the JWT tokens in Redux or localStorage
      } catch (error) {
        console.error('Error during Google login:', error);
      }
    },
    onError: (errorResponse) => {
      console.error('Google login failed', errorResponse);
    },
  });

  return (
    <Button
      onClick={googleLogin}
      sx={{
        background: theme.palette.background.default,
        borderRadius: '100px',
        boxShadow: theme.customShadows.z8,
        fontSize: '0.9375rem',
      }}
      size={'large'}
      variant="white"
    >
      <Iconify icon={'flat-color-icons:google'} sx={{ mr: 1.5 }} />
      Login With Google
    </Button>
  );
};

export default GoogleLoginForm;
